import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tooltip from '~/common/components/Tooltip';

type GenericTooltipProps = {
  children?: React.ReactNode;
  color?: string;
  icon?: any;
  label: string;
  placement?:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'top'
    | 'top-end'
    | 'top-start';
};

/**
 * Generic UWM styled tooltip
 *
 * @param {element} [children] Optional element to wrap the tooltip trigger acound
 * @param {string} [color='#3182CE'] Icon color (not applicable when children used)
 * @param {object} [icon=faInfoCircle] Font Awesome compatible icon (not applicable when children used)
 * @param {string} label The tooltip to display for the triggering children or icon
 * @param {string} [placement='top'] tooltip location
 *
 * @example basic tooltip rendering on a blue info icon
 *   `<GenericTooltip label="my tooltip" />`
 * @example customized tooltip on red key icon
 *   `<GenericTooltip color="#f00" icon="faKey" label="This is a key" placement="bottom"/>`
 * @example non-icon tooltip trigger
 *   `<GenericTooltip label="What is a keyboard">Computer Input Device</GenericTooltip>
 */
const GenericTooltip = ({
  children,
  color,
  icon,
  label,
  placement,
}: GenericTooltipProps) => (
  <Tooltip
    hasArrow
    placement={placement}
    label={label}
    textAlign="center"
    color="black"
    bg="gray.200"
    borderRadius="2px"
    fontSize="12px"
    fontWeight="normal"
    p={2}
  >
    {children ?? (
      <span
        style={{ marginLeft: '4px' }}
        role="tooltip"
        aria-label={label ?? 'Information'}
      >
        <FontAwesomeIcon color={color} icon={icon} />
      </span>
    )}
  </Tooltip>
);

GenericTooltip.defaultProps = {
  children: undefined,
  color: '#3182CE',
  icon: faInfoCircle,
  placement: 'top',
};

export default GenericTooltip;
